<template>
  <router-view/>
</template>

<script>
export default {
  name: "DelegatingView"
}
</script>

<style scoped>

</style>
